/*
  menara-ruban.js — fiche du tableau sélectionné, page Tableaux.

  Le présentoir (menara-presentoir.js) signale chaque changement de tableau ;
  ce petit élément montre la fiche correspondante. Toutes les fiches existent
  déjà dans la page : sans JavaScript, celle du tableau de départ reste
  visible et son lien fonctionne.
*/

class MenaraRuban extends HTMLElement {
  connectedCallback() {
    this.infos = Array.from(this.querySelectorAll('[data-rub-info]'));
    this.surActif = (e) => this.montrer(e.detail && e.detail.index);
    this.addEventListener('menara:presentoir-actif', this.surActif);

    // Le tableau du centre ouvre sa fiche, comme le bouton sous la scène.
    this.surClic = (e) => this.ouvrir(e);
    this.addEventListener('click', this.surClic);

    // Le présentoir a pu démarrer avant ce script : on se cale sur son état.
    const presentoir = this.querySelector('menara-presentoir');
    if (presentoir && Number.isInteger(presentoir.actif) && presentoir.actif >= 0) {
      this.montrer(presentoir.actif);
    }
  }

  disconnectedCallback() {
    this.removeEventListener('menara:presentoir-actif', this.surActif);
    this.removeEventListener('click', this.surClic);
  }

  /**
   * Ouvre la fiche du tableau du centre quand on clique dessus.
   *
   * Le présentoir a déjà tranché avant nous, en phase de capture : après un
   * glissement il arrête le clic net, et sur un tableau de côté il appelle
   * preventDefault() pour l'amener au centre. On ne regarde donc que les
   * clics qu'il a laissés passer, sur le tableau déjà actif.
   */
  ouvrir(e) {
    if (e.defaultPrevented) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (window.Shopify && window.Shopify.designMode) return;

    const item = e.target.closest('[data-mnp-item]');
    if (!item || !item.classList.contains('est-actif')) return;
    // Un lien ou un bouton fait déjà son travail tout seul.
    if (e.target.closest('a[href], button')) return;

    const bouton = this.lien();
    if (!bouton) return;
    e.preventDefault();
    window.location.href = bouton.href;
  }

  /** Le bouton de la fiche visible, s'il y en a un : « Bientôt » n'en a pas. */
  lien() {
    return this.querySelector('[data-rub-info].est-actif a.rub__bouton[href]');
  }

  montrer(index) {
    if (!Number.isInteger(index)) return;
    this.infos.forEach((el, i) => {
      const est = i === index;
      el.classList.toggle('est-actif', est);
      el.setAttribute('aria-hidden', est ? 'false' : 'true');
    });
    // Le curseur ne devient une main que si le tableau mène quelque part.
    this.classList.toggle('rub-cliquable', this.lien() != null);
  }
}

if (!customElements.get('menara-ruban')) {
  customElements.define('menara-ruban', MenaraRuban);
}
